import {createSlice} from '@reduxjs/toolkit'

export const openSavedProspectSlice = createSlice({
  name: 'openSavedProspectSlice',
  initialState: {
    allConstituentsTotalCount: 0,
    setAllConstituentsfilters: {}
  },
  reducers: {
    setAllConstituentsFilters: (state, action) => {
      state.setAllConstituentsfilters = action.payload
    },
    setAllConstituentsTotalCount: (state, action) => {
      state.allConstituentsTotalCount = action.payload
    }
  }
})

export const {setAllConstituentsFilters, setAllConstituentsTotalCount} = openSavedProspectSlice.actions

export default openSavedProspectSlice.reducer
